import Modal from "react-bootstrap/Modal";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalTitle from "react-bootstrap/ModalTitle";
import React, {useEffect, useState} from "react";
import {Form, Formik} from "formik";
import ModalBody from "react-bootstrap/ModalBody";
import * as Yup from "yup";
import {getICDx} from "../../laporan/DataProvider";
import Async from "react-select/async/dist/react-select.esm";
import {InputAlert} from "../../component/InputAlert";
import AsyncSelect from "react-select/async";
import API from "../../../apiService";
import ModalFooter from "react-bootstrap/ModalFooter";
import apiService from "../../../apiService";
import Alert from "../../component/Alert";

const ReportTypeSchema = Yup.object().shape({
    // name: Yup.string().required("Nama harus diisi"),
})

export default function ReportTypeModal(props) {

    const [name, setName] = useState('')
    const [icd_code, setIcd_code] = useState([])
    const [inputValue, setInputValue] = useState('')
    const [ages, setAges] = useState([{from: 0, to: 0, type: 'years'}])

    useEffect(() => {
        if (props.editeddata) {
            setName(props.editeddata.name)
            setIcd_code(props.editeddata.icd_map.map(v => ({value: v.id, label: `${v.code} - ${v.name}`, code: v.code})))
            setAges(props.editeddata.age_group.map(v => ({from: v.age_from, to: v.age_to, type: v.age_type})))
        }
    }, [props.editeddata])

    const resetData = () => {
        setName('')
        setIcd_code([])
        setInputValue('')
        setAges([{from: 0, to: 0, type: 'years'}])
    }

    const handleSubmit = () => {
        if (props.editeddata) {
            update()
        }
        else {
            create()
        }
    }

    const update = async () => {
        try {
            let response = await API.put("/management/icd_group/update", {
                id: props.editeddata.id,
                name: name,
                icd_code: icd_code.map(v => v.code),
                icd_age: ages.map(v => ({
                    age_type: v.type,
                    age_from: v.from,
                    age_to: v.to,
                }))
            })

            if (response.code === 200) {
                props.onHide()
                props.reloaddata()
                Alert("success", "Data master berhasil diedit")
                resetData()
            }
            else {
                console.log(response)
                Alert("error", "Gagal mengedit data. Coba lagi.")
            }
        }
        catch (e) {
            console.log(e)
            Alert("error", "Gagal mengedit data. Coba lagi.")
        }
    }

    const create = async () => {
        try {
            let response = await API.post("/management/icd_group/create", {
                name: name,
                icd_code: icd_code.map(v => v.code)
            })

            if (response.code === 200) {
                const icd_group = response.data
                for (const age of ages) {
                    await API.post("/management/icd_age_group/create", {
                        icd_group_id: icd_group.id,
                        age_type: age.type,
                        age_from: age.from,
                        age_to: age.to,
                    })
                }
                props.onHide()
                props.reloaddata()
                Alert("success", "Data master berhasil ditambahkan")
                resetData()
            }
            else {
                console.log(response)
                Alert("error", "Gagal menambahkan data. Coba lagi.")
            }
        }
        catch (e) {
            console.log(e)
            Alert("error", "Gagal menambahkan data. Coba lagi.")
        }
    }

    const loadOptions = async (inputValue, callback) => {
        try {
            const res = await API.get(`management/icd10/read?keyword=${inputValue}`)
            if (res.code === 200) {
                callback(res.data.data.map(v => ({value: v.id, label: `${v.code} - ${v.name}`, code: v.code})))
            }
        }
        catch (e) {
            callback([])
            console.log(e)
        }
    }

    return (
        <Modal
            {...props}
            aria-labelledby="modal-user"
            onHide={() => {
                props.onHide()
                resetData()
            }}
        >
            <ModalHeader closeButton>
                <ModalTitle>
                    <h3>{props.editeddata ? 'Edit' : 'Tambah'} Data Report Type</h3>
                </ModalTitle>
            </ModalHeader>
            <Formik
                enableReinitialize
                initialValues={{
                    // name: this.state.data.name,
                    // username: this.state.data.username,
                    // password: this.state.password,
                    // confirmedPassword: this.state.confirmedPassword
                }}
                validationSchema={ReportTypeSchema}
                onSubmit={values => {
                    handleSubmit()
                }}
            >
                {({ values, errors, touched }) => (
                    <Form>
                        <ModalBody>
                            <div className="form-group row">
                                <label
                                    htmlFor="example-text-input"
                                    className="col-md-4 col-form-label col-form-label-sm"
                                >
                                    Name
                                </label>
                                <div className="col-md-8">
                                    <input
                                        className="form-control form-control-sm"
                                        type="text"
                                        placeholder="Name"
                                        name="name"
                                        id="name"
                                        value={name}
                                        onChange={e => setName(e.target.value)}
                                    />
                                    {errors.name && touched.name ? (
                                        <div style={{ color: "red" }}>{errors.name}</div>
                                    ) : null}
                                </div>
                            </div>

                            <div className="form-group row">
                                <label
                                    htmlFor="example-text-input"
                                    className="col-md-4 col-form-label col-form-label-sm"
                                >
                                    ICD Code
                                </label>
                                <div className="col-md-8">
                                    <AsyncSelect
                                        cacheOptions
                                        loadOptions={loadOptions}
                                        defaultOptions
                                        isMulti
                                        onInputChange={v => {
                                            const i = v.replace(/\W/g, '')
                                            setInputValue(i)
                                            return i
                                        }}
                                        value={icd_code}
                                        onChange={e => {
                                            console.log(e)
                                            setIcd_code(e || [])
                                        }}
                                    />
                                </div>
                            </div>

                            <hr/>

                            <div className="form-group row">
                                <label
                                    htmlFor="example-text-input"
                                    className="col-md-4 col-form-label col-form-label-sm"
                                >
                                    Age
                                </label>
                                <div className="col-md-8">
                                    {ages.map((v, k) => (
                                        <div className="row" key={k} style={{marginBottom: 8, paddingLeft: 15}}>
                                            <div className="col-md-2" style={{padding: 0}}>
                                                <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    value={v.from}
                                                    onChange={e => {
                                                        const newAges = [...ages]
                                                        newAges[k] = {...ages[k], from: e.target.value}
                                                        setAges(newAges)
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-1" style={{padding: 0, textAlign: 'center'}}>
                                                -
                                            </div>
                                            <div className="col-md-2" style={{padding: 0}}>
                                                <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    value={ages[k].to}
                                                    onChange={e => {
                                                        const newAges = [...ages]
                                                        newAges[k] = {...ages[k], to: e.target.value}
                                                        setAges(newAges)
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-5">
                                                <select
                                                    className="form-control form-control-sm"
                                                    onChange={e => {
                                                        const newAges = [...ages]
                                                        newAges[k] = {...ages[k], type: e.target.value}
                                                        setAges(newAges)
                                                    }}
                                                >
                                                    <option value='years'>Years</option>
                                                    <option value='months'>Months</option>
                                                    <option value='days'>Days</option>
                                                </select>
                                            </div>
                                            <div className="col-md-2" style={{padding: 0}}>
                                                <button
                                                    style={{margin: 0}}
                                                    type="button"
                                                    className="btn btn-sm btn-danger"
                                                    data-toggle="collapse"
                                                    data-target="#collapsePreview"
                                                    aria-expanded="false"
                                                    aria-controls="collapsePreview"
                                                    onClick={() => {
                                                        let newAge = [...ages]
                                                        newAge.splice(k, 1)
                                                        setAges(newAge)
                                                    }}
                                                >
                                                    <span className="btn-inner--icon">
                                                        <i className="ni ni-fat-delete"/>
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                    <button
                                        style={{margin: 0}}
                                        type="button"
                                        className="btn btn-sm btn-primary  align-items-right"
                                        data-toggle="collapse"
                                        data-target="#collapsePreview"
                                        aria-expanded="false"
                                        aria-controls="collapsePreview"
                                        onClick={() => setAges([...ages, {from: 0, to: 0, type: 'years'}])}
                                    >
                                        <span className="btn-inner--icon">
                                            <i className="ni ni-fat-add"/>
                                        </span>
                                        <span className="btn-inner--text"> Add</span>
                                    </button>
                                </div>
                            </div>

                        </ModalBody>
                        <ModalFooter>
                            <div className="row">
                                <div className="col-12">
                                    <button
                                        type="submit"
                                        className="btn btn-outline-secondary"
                                        onClick={() => {
                                            props.onHide()
                                        }}
                                    >
                                        Batal
                                    </button>
                                    <button
                                        onClick={handleSubmit}
                                        type="button"
                                        className="btn btn-primary">
                                        Simpan
                                    </button>
                                </div>
                            </div>
                        </ModalFooter>
                    </Form>
                )}
            </Formik>
        </Modal>
    )
}